import { useState } from "react";
import { NavLink, Route, Routes } from "react-router-dom";
import CapturePage from "./pages/CapturePage";
import CoordsPage from "./pages/CoordsPage";
import * as store from "./store";
import type { CaptureNotebook } from "./types";

export const APP_VERSION = "0.1.0";
/** Keep in sync with the capture-zone consts in src/geo/bounds.ts. */
export const ZONE_LABEL = "UCSI KL · Cheras";

export default function App() {
  const [notebook, setNotebook] = useState<CaptureNotebook>(store.loadNotebook);

  const update = (next: CaptureNotebook) => {
    setNotebook(next);
    store.saveNotebook(next);
  };

  const reset = () => {
    store.clearNotebook();
    setNotebook(store.loadNotebook());
  };

  return (
    <div className="shell">
      <header className="topbar">
        <div className="brand">
          <span className="brand-mark">▲</span>
          <div>
            <div className="brand-name">attenducsi · block capture</div>
            <div className="brand-sub">{ZONE_LABEL}</div>
          </div>
        </div>
        <nav className="nav">
          <NavLink to="/" end>
            Capture
          </NavLink>
          <NavLink to="/coords" end>
            All coords
            <span className="nav-count">{notebook.blocks.length}</span>
          </NavLink>
        </nav>
      </header>

      <main className="content">
        <Routes>
          <Route path="/" element={<CapturePage notebook={notebook} onUpdate={update} />} />
          <Route
            path="/coords"
            element={<CoordsPage notebook={notebook} onUpdate={update} onReset={reset} />}
          />
        </Routes>
      </main>
    </div>
  );
}